import React, { lazy, Suspense, useEffect, useState } from "react";
import "../src/App.css";
import Header from "./components/Header";
import Body from "./components/Body/Body";
import Bodymobile from "./components/Body/Bodymobile";
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import axios from "axios";
import MediaQuery from "react-responsive";
import { CookieSetting } from "cookiesetting-component";
import jsonData from "./components/ai-branding.json";

const Footer = lazy(() => import("./components/FooterNew/index"));
const Gallerynew = lazy(() => import("./components/Headercarousel/Gallerynew.js"));

function App() {
  // const isProduction = process.env.NODE_ENV === 'production';

  const appVersion = appversion.version;
  // console.log(appVersion);

  const [links, setLinks] = useState(null); // Set initial state as null

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);



  return (
    <>
      <CacheBuster
        currentVersion={appversion.version}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
        // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
        //If public assets are hosted somewhere other than root on your server.
        metaFileDirectory={process.env.PUBLIC_URL}
      >
        <div className="bodyContainer">
          {links ? (
            <>
              <Header links={links} />
              <MediaQuery minWidth={992}>
                <Suspense fallback={<div />}>
                  <Body links={links} />
                </Suspense>
              </MediaQuery>
              <MediaQuery maxWidth={991}>
                <Suspense fallback={<div />}>
                  <Bodymobile links={links} />
                </Suspense>
              </MediaQuery>
              <Suspense fallback={<div />}>
                <Footer links={links} />
              </Suspense>
              <CookieSetting 
                privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
                configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
                analytics={process.env.REACT_APP_ANALYTICS_PATH}
              />
            </>
          ) : (
            <div>Loading...</div>
          )}
        </div>
      </CacheBuster>
    </>
  );
}

export default App;
